import { useI18n } from "../i18n/LanguageContext";
import { useSeo } from "../hooks/useSeo";

export default function Privacy() {
  const { t, lang } = useI18n();
  useSeo({ title: t.seo.privacy.title, description: t.seo.privacy.description, path: "/privacy", lang });
  const today = new Date().toISOString().slice(0, 10);

  return (
    <section className="container-wide py-16 md:py-24">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <p className="eyebrow">Legal</p>
          <h1 className="mt-5 text-4xl md:text-5xl lg:text-6xl tracking-[-0.025em] font-medium text-foreground leading-[1.02]">
            {t.legal.privacy.title}
          </h1>
          <p className="mt-6 text-xs uppercase tracking-[0.22em] text-muted-foreground font-bold">
            {t.legal.privacy.updated} — {today}
          </p>
        </div>
        <div className="lg:col-span-8">
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">{t.legal.privacy.intro}</p>
          <div className="mt-10 border-y border-border">
            {t.legal.privacy.sections.map((s, i) => (
              <div key={i} className="py-7 border-b border-border last:border-b-0">
                <h2 className="text-lg md:text-xl text-foreground font-medium tracking-tight">{s.t}</h2>
                <p className="mt-3 text-muted-foreground leading-relaxed">{s.b}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
